import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface SitemapImportParams {
	sitemap: string;
	contentSelector?: string;
	titleSelector?: string;
	postImageSelector?: string;
	postContentSelector?: string;
	locationPrefix?: string;
	impersonationContext?: Api.IImpersonationContext;
}

interface SitemapImportSystemJob {
	id: string;
	status: string;
	progress?: number;
	errorMessage?: string;
	resultData?: any;
}

export function useBlogSitemapImportMutation({
	onError,
	onSuccess,
}: {
	onError?: (err: Api.IOperationResultNoValue) => void;
	onSuccess?: (job: SitemapImportSystemJob) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: async (params: SitemapImportParams) => {
			const { impersonationContext, ...queryParams } = params;
			const queryString = new URLSearchParams(
				Object.entries(queryParams).reduce(
					(acc, [key, value]) => {
						if (value !== undefined && value !== null && value !== '') {
							acc[key] = String(value);
						}
						return acc;
					},
					{} as Record<string, string>
				)
			).toString();

			const response = await userSession.webServiceHelper.callAsync<SitemapImportSystemJob>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `blog/sitemapImport?${queryString}`,
				}),
				'POST'
			);
			return response;
		},
		onError,
		onSuccess,
	});
}
